import { render, staticRenderFns } from "./TrasladosReserva.vue?vue&type=template&id=a3eee0b8&"
import script from "./TrasladosReserva.vue?vue&type=script&lang=js&"
export * from "./TrasladosReserva.vue?vue&type=script&lang=js&"
import style0 from "./TrasladosReserva.vue?vue&type=style&index=0&id=a3eee0b8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports